import L from 'leaflet';  
  
  // converts the given GeoJSON Point coordinates [long, lat] to Leaflet LatLng format [lat, long]
  const getLatLng = (coordinates) => {
    return L.latLng(coordinates[1], coordinates[0]);
  }

  export {
    getLatLng
  }